module.exports = __webpack_public_path__ + "static/media/land.8663c2d5.svg";